import styled from 'styled-components';

export default styled.p`
  width: 350px;
  max-width: 70vw;
  margin-bottom: 0;
`;
